module.exports = __webpack_public_path__ + "images/infophrafics-image.63c3e373.png";